import React from 'react'

interface Props {
  calendarException?: string
}

function Reason({ calendarException = '' }: Props) {
  return <span>{calendarException}</span>
}

export default Reason
